<template>
  <div v-bind="$attrs">
    <v-form
      ref="form"
      v-model="valid"
      data-testid="so-form"
      :disabled="disabled"
      :autocomplete="autocomplete ? 'on' : 'off'"
      :reset="reset"
      @submit.prevent="submit"
    >
      <slot />
      <slot
        name="actions"
        :validate="validate"
        :reset="reset"
        :reset-validation="resetValidation"
      />
    </v-form>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { VForm } from "vuetify/components"

  export default defineComponent({
    inheritAttrs: false,
    props: {
      modelValue: {
        type: Boolean as PropType<boolean | null | undefined>,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      autocomplete: {
        type: Boolean,
        default: true,
      },
    },
    emits: ["update:modelValue", "submit"],
    computed: {
      valid: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
    },
    methods: {
      async submit() {
        const form = this.$refs.form as InstanceType<typeof VForm>
        const { valid } = await form.validate()
        if (valid) {
          this.$emit("submit")
        }
      },
      validate() {
        const form = this.$refs.form as InstanceType<typeof VForm>
        return form.validate()
      },
      reset() {
        const form = this.$refs.form as InstanceType<typeof VForm>
        form.reset()
      },
      resetValidation() {
        const form = this.$refs.form as InstanceType<typeof VForm>
        form.resetValidation()
      },
    },
  })
</script>
